// extracted by mini-css-extract-plugin
export default {"SpeakerItem":"SpeakersList-module-d099fedad2265cfeb24a","avatar":"SpeakersList-module-c14032abb3ea35e1d4a7"};